/**
 * Initialize blocks and set conditions according to the device
 *
 */
export function initScrollToTop() {
    [...document.querySelectorAll('.c-scroll-to-top:not(.-initialiazed)')].forEach((item) => handleScrollToTop(item));
}

/**
 * Handle ScrollToTop
 * @param {HTMLElement} group
 */
function handleScrollToTop(group) {
    group.classList.add('-initialiazed');
    group.classList.remove('initial-hidden');

    let scrollEl = document.querySelector('.c-scroll-to-top div');
    const threshold = 1.5; // threshold for showing the button, adjust as needed

    // Function to check if scroll-to-top button should be visible
    function checkScroll() {
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop === 0) {
            group.style.opacity = '0';
            group.style.pointerEvents = 'none';
        } else if (scrollHeight > clientHeight * threshold) {
            group.style.opacity = '1';
            group.style.pointerEvents = 'auto';
        } else {
            group.style.opacity = '0';
            group.style.pointerEvents = 'none';
        }
    }

    if (scrollEl) {
        scrollEl.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        // Initial check
        checkScroll();

        // Check on window resize and scroll
        window.addEventListener('resize', checkScroll);
        window.addEventListener('scroll', checkScroll);

        // Hide button when scroll animation is done
        window.addEventListener('scroll', () => {
            if (window.scrollY === 0) {
                group.style.opacity = '0';
                group.style.pointerEvents = 'none';
            }
        });
    }
}
